const navColumn = [
  { label: "合集索引", href: "#collections" },
  { label: "快讯流", href: "#stream" },
  { label: "封面墙", href: "#covers" },
  { label: "浏览指引", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

const typeColumn = [
  { label: "现场实拍", href: "#stream" },
  { label: "现场直击", href: "#stream" },
  { label: "录制片段", href: "#stream" },
  { label: "围观合集", href: "#collections" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <a href="#top" className="flex cursor-pointer items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-camera-lens-line text-xl" />
              </span>
              <span className="font-heading text-2xl font-bold tracking-wide text-background-50">
                私拍吃瓜
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-300">
              一个以现场实拍、直击与录制片段为主的专题合集站。首页把入口条、合集索引与时间线排在一起，翻现场时不必再到处找帖。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-50/20 text-background-300">
                <i className="ri-camera-line text-base" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-50/20 text-background-300">
                <i className="ri-live-line text-base" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-50/20 text-background-300">
                <i className="ri-bookmark-3-line text-base" />
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-semibold tracking-wider text-accent-300">
              站内导航
            </h3>
            <ul className="mt-5 flex flex-col gap-3">
              {navColumn.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-semibold tracking-wider text-accent-300">
              现场分类
            </h3>
            <ul className="mt-5 flex flex-col gap-3">
              {typeColumn.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-6 flex items-center gap-2 text-xs text-background-400">
              <i className="ri-shield-check-line text-sm" />
              本站为静态展示页，内容仅供浏览参考
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 私拍吃瓜 · 现场实拍与直击合集
          </p>
          <a
            href="#top"
            className="flex cursor-pointer items-center gap-1.5 text-xs text-background-300 transition-colors hover:text-background-50"
          >
            回到顶部
            <i className="ri-arrow-up-line text-sm" />
          </a>
        </div>
      </div>
    </footer>
  );
}